/*
 * What every page needs before Alpine starts. Both entries import this and
 * call start() last; nothing else may call Alpine.start().
 *
 * Alpine is bundled (npm, pinned in package.json) rather than loaded from a
 * CDN, so each bundle carries its own copy and registers its own components:
 * a page loads exactly one bundle, never two.
 *
 * Order matters here and is deliberate: i18n, format and describe-alert set
 * window.t / window.fmt / window.describe, and Alpine's inline expressions
 * read those as globals. A global is not a reactive dependency, so it must
 * exist before the first render or a binding keeps its fallback forever.
 */
import Alpine from 'alpinejs';
import '../lib/i18n.js';
import '../lib/format.js';
import '../lib/describe-alert.js';
import data from '../lib/root-data.js';
import { registerToastStore } from '../lib/toast.js';
import { initTracking } from '../lib/track.js';

window.Alpine = Alpine;

// <html x-data="data()"> on every page
Alpine.data('data', data);
registerToastStore(Alpine);

export { Alpine };

export function start() {
  initTracking();   // first-party usage log, see lib/track.js
  Alpine.start();
}
